import {Value} from "./value";
import {UnitType} from "./unitType";

export class MillimetersSquared extends Value {
    constructor(value: number) {
        super(value, UnitType.MM2);
    }
}
